import { FlightType } from '../model/types';

/**
 * Тип перелёта из ответа поиска. Поле не валидируется и в ответе бывает пустым, поэтому
 * функция тотальна: чартером считается всё, кроме явного `regular`, — так же, как на десктопной
 * выдаче. Пустой тип перелёта иначе прятал бы у тура «по запросу» его тип подтверждения.
 */
export function getFlightType(value: string | undefined): FlightType {
  return value === FlightType.Regular ? FlightType.Regular : FlightType.Charter;
}
